
document.addEventListener('DOMContentLoaded', ()=> {
    var mySwiper = new Swiper('.swiper-container.collection-list--home', {  
        spaceBetween: 6,  
        slidesPerView: 2.5,  
        grabCursor: true,  
        freeMode: true,  
        slidesPerGroup: 1,
        loop: false,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {  
            640: {          // When the viewport is 640px or smaller  
                slidesPerView: 2.5,
            },  
            768: {          // When the viewport is 768px or smaller  
                slidesPerView: 4 // Set slides per view to 2  
            },  
            1024: { // When viewport is 768px or smaller  
                slidesPerView: 5, // Set this to a number if you want specific counts  
            },  
            1400: { // When the viewport is 1024px or larger
                slidesPerView: 9
            }  
        }  
        
    }); 
    

})

